import { apiClient } from "../apiClient";

export const DANH_SACH_TOT_NO_NGHIEP_ENDPOINT = 'danh-sach-no-tot-nghiep';
export const danhSachNoTotNghiepApi = {
    SelectByDotXet: (id_xet_tot_nghiep: number) => apiClient.get(`${DANH_SACH_TOT_NO_NGHIEP_ENDPOINT}/dot-xet/${id_xet_tot_nghiep}`),
}